import AxiosService from "./axiosServices";

const axiosService = new AxiosService();
const configUrl = process.env.REACT_APP_APIBASE + "/";

export default class PreProcessor {
  getHeaders = () => {
    return {
      headers: {
        "Content-Type": "Application/json",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: localStorage.getItem("token"),
      },
    };
  };

  createNewProject = ({ projectName, drugType }) => {
    const data = { body: { project_name: projectName, drug_type: drugType } };
    return axiosService.Post(
      `${configUrl}api/create-project/`,
      data,
      this.getHeaders()
    );
  };
  uploadMultipleFilesToServer = (fileContent) => {
    const jsonData = [];
    const fileNameList = [];
    for (let key in fileContent) {
      jsonData.push({
        pdfpath: fileContent[key].filePath,
        tagname: fileContent[key].tagName,
        original_filename: fileContent[key].fileName,
      });
      fileNameList.push(fileContent[key].fileName);
    }
    const data = {
      body: {
        files_paths: jsonData,
        project_id: localStorage.projectId,
        file_name_list: fileNameList,
      },
    };

    return axiosService.Post(
      `${configUrl}api/upload-batch-records/`,
      data,
      this.getHeaders()
    );
  };
  getProjects = (obj) => {
    const { type, formattedStartDate, formattedEndDate, status } = obj;
    let params = {};

    if (type == "project") {
      params = {
        created_project_after: formattedStartDate,
        created_project_before: formattedEndDate,
      };
    } else {
      let boolStatus = "";
      if (status === "draft") {
        boolStatus = false;
      } else if (status === "assigned") {
        boolStatus = true;
      }

      params = {
        created_batch_after: formattedStartDate,
        created_batch_before: formattedEndDate,
        pre_pro_status: boolStatus,
      };
    }

    return axiosService.Get(`${configUrl}api/landing-page/`, {
      ...this.getHeaders(),
      params: params,
    });
  };

  createBatch = (batchName, projectId) => {
    const data = {
      body: {
        project_id: projectId,
        batch_name: batchName,
      },
    };
    return axiosService.Post(
      `${configUrl}api/create-batch/`,
      data,
      this.getHeaders()
    );
  };

  uploadTemplateAndOpFormat = (selectedFiles) => {
    const data = {
      body: {
        template_path: selectedFiles.templatePath,
        op_file_path: selectedFiles.opFormatPath,
        project_id: Number(selectedFiles.projectId),
      },
    };

    return axiosService.Post(
      `${configUrl}api/upload-template-and-op-format/`,
      data,
      this.getHeaders()
    );
  };

  getUploadedTemplateAndOpFormat = (projectId) => {
    const data = {
      body: {
        project_id: projectId,
      },
    };

    return axiosService.Post(
      `${configUrl}api/get-template-and-op-detail/`,
      data,
      this.getHeaders()
    );
  };

  getTags = (projectId) => {
    const data = {
      body: {
        project_id: projectId,
      },
    };

    return axiosService.Post(
      `${configUrl}api/get-tags/`,
      data,
      this.getHeaders()
    );
  };

  uploadBatchPdfs = (selectedFiles, projectId, batchId, checked) => {
    let files_paths = [];
    let file_name_list = [];
    selectedFiles.map(
      (item) => (
        files_paths.push({
          pdfpath: item.pdfPath,
          original_filename: item.pdfName,
          tagname: item.tagName,
        }),
        file_name_list.push(item.pdfName)
      )
    );

    const data = {
      body: {
        project_id: projectId,
        batch_id: batchId,
        files_paths: files_paths,
        file_name_list: file_name_list,
        auto_extraction: checked,
      },
    };

    return axiosService.Post(
      `${configUrl}api/upload-batch-records/`,
      data,
      this.getHeaders()
    );
  };
  getUserList = () => {
    return axiosService.Get(
      `${configUrl}api/get-users-list/`,
      this.getHeaders()
    );
  };

  getTagsAndPdf = (projectId, batchId) => {
    const data = {
      body: {
        project_id: projectId,
        batch_id: batchId,
      },
    };

    return axiosService.Post(
      `${configUrl}api/get-tag-and-pdf/`,
      data,
      this.getHeaders()
    );
  };
  esignHandle = (userName, userId, userRole, userPassword) => {
    const data = {
      body: {
        user_name: userName,
        user_id: userId,
        user_role: userRole,
        user_password: userPassword,
      },
    };
    return axiosService.Post(
      `${configUrl}api/verify-user/`,
      data,
      this.getHeaders()
    );
  };

  isSignatureUploaded = () => {
    return axiosService.Get(
      `${configUrl}api/is-signature-uploaded/`,
      this.getHeaders()
    );
  };
  userPermission = (authData) => {
    const data = {
      body: {
        username: authData.userName,
        project_id: authData.projectId,
        batch_id: authData.batchId,
        end_date: authData.endDate,
        subject: authData.subject,
        remark: authData.remark,
      },
    };
    return axiosService.Post(
      `${configUrl}api/assign-processor/`,
      data,
      this.getHeaders()
    );
  };

  getUploadedPdfsWithTags = async (projectId) => {
    const data = {
      body: {
        project_id: projectId,
      },
    };

    const res = await axiosService.Post(
      `${configUrl}api/get-tag-and-pdf/`,
      data,
      this.getHeaders()
    );
    return res;
  };

  getCoorData = (projectId) => {
    const data = {
      body: {
        project_id: projectId,
      },
    };

    return axiosService.Post(
      `${configUrl}api/get-details-for-mapping/`,
      data,
      this.getHeaders()
    );
  };
  getS3Files = (fileType, subFolder) => {
    const params = { file_type: fileType, sub_folder: subFolder };
    return axiosService.Get(`${configUrl}api/list-dir/`, {
      ...this.getHeaders(),
      params: params,
    });
  };

  mapData = (payloadData) => {
    const data = {
      body: payloadData,
    };

    return axiosService.Post(
      `${configUrl}api/save-mapping-details/`,
      data,
      this.getHeaders()
    );
  };

  getSheetsNames = (project_id) => {
    const data = { body: { project_id: project_id } };
    return axiosService.Post(
      `${configUrl}api/get-sheet-names/`,
      data,
      this.getHeaders()
    );
  };

  getOutputFormat = (subFolder) => {
    const params = { file_type: "op_format", sub_folder: subFolder };
    return axiosService.Get(`${configUrl}api/list-dir/`, {
      ...this.getHeaders(),
      params: params,
    });
  };
  getProjectFiles = () => {
    return axiosService.Get(`${configUrl}api/get-drug-types/`, {
      ...this.getHeaders(),
    });
  };
  clone = (projectName) => {
    const data = { body: { project_id: localStorage.projectId, project_name: projectName } };
    return axiosService.Post(
      `${configUrl}api/clone-project/`,
      data,
      this.getHeaders()
    )
  }
}
